import React from "react";
import { FDialog, FList, FListItem, FTruncateText } from "ferrum-design-system";
import { useAlgoSignerWalletConnector } from "foundry";

export const SelectWalletAddressDialog = ({
  show,
  onHide,
  selectAlgorandWalletAddress,
}: any) => {
  const { walletAddresses } = useAlgoSignerWalletConnector();

  return (
    <FDialog
      show={show}
      onHide={onHide}
      variant="futuristic-primary"
      size="small"
      className="dialog-connect-wallet text-center"
    >
      <FList display="block" type="circle" variant="connect-wallet">
        {walletAddresses && walletAddresses.length
          ? walletAddresses.map((walletAddress: any, index: number) => {
              return (
                <FListItem
                  key={index}
                  display="block"
                  onClick={() => {
                    selectAlgorandWalletAddress(walletAddress.address);
                    onHide();
                  }}
                >
                  <small>
                    <FTruncateText text={walletAddress.address} />
                  </small>
                </FListItem>
              );
            })
          : null}
      </FList>
    </FDialog>
  );
};
